import { render, staticRenderFns } from "./BsRadioGroup.vue?vue&type=template&id=432e8b79&"
import script from "./BsRadioGroup.vue?vue&type=script&lang=js&"
export * from "./BsRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./BsRadioGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports